import React, { useState } from 'react';
import { Button, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { useMsal } from "@azure/msal-react";
import Styles from './SignInButton.module.css';
import LoginIcon from "./assets/login-icon.png";

function SignInButton({ loginType, onSuccess, onError }) {
    const { instance } = useMsal();
    const [selectedLoginType, setSelectedLoginType] = useState(loginType ?? 'redirect');

    const handleLogin = () => {
      if (selectedLoginType !== "redirect") {
        instance.loginPopup()
        .then((authData) => {
          if (typeof onSuccess === 'function') {
            onSuccess(authData);
          }
        }).catch(e => {
          if (typeof onError === 'function') {
            onError(e);
          }
        });
      } else {
        instance.loginRedirect({
          redirectUri: "/auth/login",
          redirectStartPage: "/auth/login"
        }).catch(e => {
          console.log(e);
      });
      }
    }

    const handleLoginTypeChange = (loginTypeChange) => {
      setSelectedLoginType(loginTypeChange);
    }

    const CheckMark = (props) => {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={props.width ?? 16}
          height={props.height ?? 16}
          fill={props.fill ?? "currentColor"}
          className={"bi bi-check " + (props.className ?? '')}
          viewBox={props.viewBox ?? "0 0 16 16"}>
          <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75
                  0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094
                  2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"
          />
        </svg>
      )
    }

    return (
      <UncontrolledDropdown
        group 
        className={Styles.dropDownGradient} 
      >
        <Button 
          variant="secondary"
          className="ml-auto text-white text-bold d-inline-flex align-items-center ps-3 pe-1 bg-transparent border-0"
          onClick={() => handleLogin()}
        >
          <img src={LoginIcon} className={Styles.loginIcon + ' me-2'} alt="Sign in"/>
          Sign in
        </Button>
        <DropdownToggle caret color="secondary" className="pe-3 builde-login-dropdown ps-0 bg-transparent border-0 shadow-none"/>
        <DropdownMenu>
          <DropdownItem header>
            Select Login Type
          </DropdownItem>
          <DropdownItem divider />
          <DropdownItem onClick={() => handleLoginTypeChange('popup')}>
            <span className='me-1'>PopUp Login</span>
            { 
              selectedLoginType === 'popup' ? (
                <CheckMark width="20" height="20"/>
              ) : (
                ''
              )
            }
          </DropdownItem>
          <DropdownItem onClick={() => handleLoginTypeChange('redirect')}>
            <span className='me-1'>Redirect Login</span>
            {
              selectedLoginType === 'redirect' ? (
                <CheckMark width="20" height="20"/>
              ) : (
                ''
              )
            } 
          </DropdownItem>
        </DropdownMenu>        
      </UncontrolledDropdown>
    );
}

export default SignInButton;
